export const searchServerConfig = {
    apiKey: "Kpl52zwBljrkBNEMHsrzvJM5Jqjd7D0uoGfXGZ8oWOv7lFl5",
    connectionTimeoutSeconds: 10,
    nodes: [{
        host: "typesense-server.cr38te.com",
        port: 443,
        protocol: "https"
    }],
    searchServerHost: "typesense-server.cr38te.com",
}